require('./fallbackDefinitions');
require('frontend-controller/client/utils');

// init vendor styles
require('gsap/TweenMax');
require('gsap/Draggable');
require('plupload');

require('./vendor/normalize-css/style.less');
// require('./vendor/flag-icons/style.less');                          // minified: 54 KB
require('./styles/index.less');

// init config
require('frontend-controller/client/config').setConfig(
    require('./clientAppConfig'),
    {
        templates:  require.context('./components/', true, /^\.\/(?!mails\/).*\.ejs$/),
        components: require.context('./components/', true, /^\.\/(?!mails\/).*\.js$/),
        styles:     require.context('./components/', true, /^\.\/(?!mails\/).*\.less$/)
    }
);

// init
require('frontend-controller/client/app');
